import "./App.css";
import "./header.css";
import "./leading.css";
import "./layout.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Footer from "./components/common/Footer";
import Contact from "./view/Contact";
import { Route, Routes } from "react-router-dom";
import Home from "./view/Home";
import Qatar from "./view/Qatar";
import { useScreenFixedProvider } from "../src/components/context/ScreenFixedProvider";
import { useEffect } from "react";
import Header from "./components/Header";
import Lenis from "@studio-freight/lenis";

function App() {
  AOS.init({
    once: true,
    duration: 800,
    delay: 50,
  });

  const { showOverlay } = useScreenFixedProvider();
  useEffect(() => {
    if (showOverlay) {
      document.body.classList.add("setClass");
    } else {
      document.body.classList.remove("setClass");
    }
  }, [showOverlay]);

  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    direction: "vertical",
    gestureDirection: "vertical",
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: false,
    touchMultiplier: 2,
    infinite: false,
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);

  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/qatar" element={<Qatar />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
